/* global module, require */
const THREE = require('three');

module.exports = new THREE.MeshPhongMaterial({
	color: 0xa4a8ff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});
